import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';

@Directive({
  selector: '[appDisableMultipleClicks]'
})
export class DisableMultipleClicksDirective {

  @Input() tiempoEspera = 3000; // Tiempo en milisegundos por defecto
  private clicBloqueado = false;
  er = inject(ElementRef);  

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    console.log(`Bloqueado por ${this.tiempoEspera} seg`);
    if (!this.clicBloqueado) {
      this.clicBloqueado = true;
      this.er.nativeElement.disabled = true; // Bloquea el botón
      setTimeout(() => {
        this.clicBloqueado = false;
        this.er.nativeElement.disabled = false; // Habilita el botón
      }, this.tiempoEspera); // Desbloquea el clic después de 3 segundo
    } else {
      event.preventDefault();
      event.stopPropagation();
    }     
  }  

}
